import DesignTokens from '@tableau/design-tokens';
import { NavigationArrowRightIcon } from '@tableau/icons/NavigationArrowRightIcon';
import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';

import { openReactActionDialog } from '~commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { BaasEdgePoolAndCluster } from '~src/settings/dataconnect-settings/serverApi/resources/BaasEdgePoolAndCluster';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

import { IAssignClusterToPoolParams, IAssignClusterToPoolResult } from '../../serverApi/requests/AssignClusterToPoolRequest';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';
import { AssignClusterDialogBody, AssignClusterDialogProps, AssignClusterDialogState } from './AssignClusterDialogBody';

const buttonsContainerStyle = style({
  padding: 5,
  borderBottom: `1px solid ${applyColor(DesignTokens.color.elevation.border.default.subtle, TabStyles.Colors.L2_5)}`,
  background: applyColor(DesignTokens.color.elevation.surface.default.default, 'white'),
  display: 'flex',
});

const innerContainerStyle = style({
  width: 700,
  paddingLeft: 85,
  display: 'flex',
});

export interface AssignClusterButtonProps {
  poolId: string;
  poolName: string;
  siteId: string;
  refreshPoolsAndClusters: () => void;
}

export interface AssignClusterButtonState {
  clusterId: string;
}


export function AssignClusterButton(props: AssignClusterButtonProps) {

  return (
    <span className={'tb-data-grid-icon tb-padded-left-small'} data-tb-test-id={'cluster-actions-menu-cell'}>
        <ButtonWidget
          testId={'cluster-add-node-script'} buttonType={ButtonType.Outline}
          onClick={() => openAssignClusterDialog(props.poolId, props.poolName, props.siteId, props.refreshPoolsAndClusters)}
          style={{marginRight: 10, paddingRight:5,  paddingLeft:5, borderColor:'transparent'}}
        >
          <NavigationArrowRightIcon size={14} alt={''} className={assignClusterIconClass} />
          <span>{Messages.dataConnectSiteSettingsAssignClusterButton()}</span>
        </ButtonWidget>
    </span>
  );
}


export function openAssignClusterDialog(poolId: string, poolName: string, siteId: string, refreshPoolsAndClusters: () => void) {

  const assignAction = (_: AssignClusterDialogProps, state: AssignClusterDialogState) => {
    const assignClusterParam: IAssignClusterToPoolParams = {
      poolId: poolId,
      clusterId: state.clusterId,
    };
    BaasEdgePoolAndCluster.assignClusterToPool(assignClusterParam)
      .then((result: IAssignClusterToPoolResult) => {
        if(result.success) {
          ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsAssignClusterToPoolSuccess({ CLUSTER_NAME: state.clusterName, POOL_NAME: poolName }) });
          refreshPoolsAndClusters();
        }
        if(result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
        });
        }
      });
    return Promise.resolve();
  };

  const dialogInstance = openReactActionDialog({
    title: Messages.dataConnectSiteSettingsAssignClusterToPool(),
    bodyComponent: AssignClusterDialogBody,
    initialBodyProps: { description: Messages.dataConnectSiteSettingsAssignClusterDescription(),
                        poolId: poolId,
                        siteId: siteId
                      },
    initialDialogState: { hasError: false, clusterId: '', clusterName: 'Search for cluster name'},
    actionName: Messages.dataConnectSiteSettingsAssignClusterButtonSave(),
    action: assignAction,
    actionDisabled: (_, state: AssignClusterDialogState) => false,
    dismissDialogOnActionFailed: true,
    dialogWidth: TabDialogWidth.width500px,
    hideCancelButton: false,
    showCloseButton: true
  });

  return Promise.resolve(dialogInstance.result);
}
const assignClusterIconClass = cssClass('assign-cluster', 'icon', {
  verticalAlign: 'middle',
  paddingRight: 3
});
